import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    minWidth: '250px',
  },
});

const FilterGroupColumn = ({
  children,
  classes,
  className,
  ...rest
}) => {
  return (
    <div className={classNames(classes.root, className)} {...rest}>
      {children}
    </div>
  );
};

FilterGroupColumn.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

FilterGroupColumn.defaultProps = {
  className: '',
};

export default withStyles(styles)(FilterGroupColumn);
